module.exports = __webpack_public_path__ + "static/img/2.a4429f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/33/2.png
// module id = z1I7
// module chunks = 0